import React from 'react'
import NavBar from '../components/NavBar'
import Footer from '../components/Footer'
import HeroImg2 from '../components/HeroImg2'
// import PricingCards from '../components/PricingCards'n
import Work from '../components/Work'

const Projects = () => {
  return (
      <div><NavBar/>
      <HeroImg2 heading="PROJECTS." text="Some of my Recent Works"/>
      <Work/>
      {/* <PricingCards/> */}
      <Footer/></div>
  )
}

export default Projects